import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import ConnectionEventEmiter from './events';
import { XHRMessages } from '../interfaces';

interface Headers {
    [key: string]: string
}

class ConnectionClient {
    public api = axios.create();
    public emiter = new ConnectionEventEmiter(document);

    constructor() {
        const accessToken = localStorage.getItem('jwt');
        if (accessToken) {
            this.api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
                (config.headers as Headers) = {
                    ...(config.headers as Headers),
                    Authorization: `Bearer ${accessToken}`
                };
                return config;
            });

            this.api.interceptors.response.use(
                (response) => response,
                (error: AxiosError) => {
                    if (error.response?.status === 401) {
                        this.emiter.publish("event_response", {
                            data:
                            {
                                status: 401,
                                message: XHRMessages.TokenExpired
                            }
                        });
                    } else if (error.response?.status === 400) {
                        this.emiter.publish("event_response", {
                            data:
                            {
                                status: 400,
                                message: XHRMessages.BadRequest
                            }
                        });
                    } else if (error.response?.status === 404) {
                        this.emiter.publish("event_response", {
                            data:
                            {
                                status: 404,
                                message: XHRMessages.NoFound
                            }
                        });
                    } else if (error.response?.status === 403) {
                        this.emiter.publish("event_response", {
                            data:
                            {
                                status: 403,
                                message: XHRMessages.Rejected
                            }
                        });
                    } else {
                        /*this.emiter.publish("event_response", {
                            data:
                            {
                                status: 500,
                                message: XHRMessages.InternalErrror
                            }
                        });*/

                        return Promise.reject(error);
                    }
                }
            );
        }
    }
}

export default ConnectionClient;